import { Box, Button, CircularProgress, FormControl, Grid, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';

import { Link } from 'react-router-dom';

import { useEffect, useState } from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { format } from 'date-fns';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { useSelector } from 'react-redux';
import { RootState } from '../../../app/store';
import { Acompanhamento, ISacompanhamento } from '../../../types/processo/Acompanhamento';
import { ISprocesso } from '../../../types/processo/Processo';
import { useDeleteAcompanhamentoMutation, useGetAcompanhamentosByProcessoQuery } from './acompanhamentoApiSlice';
import configUrls from '../../../config/configUrls';
import { GridDeleteIcon } from '@mui/x-data-grid';
import ConfirmDialogList from '../../../components/ConfirmDialogList';

export const ProcessoAcompanhamentoList = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const [acompanhamentos, setAcompanhamentos] = useState<Acompanhamento[]>([]);
  const [acompanhamentoToDelete, setAcompanhamentoToDelete] = useState<Acompanhamento>(ISacompanhamento);
  const [openConfirmExcluir, setOpenConfirmExcluir] = useState(false);
  const [deleteAcompanhamento, { error: erroDelete, isLoading, isSuccess }] = useDeleteAcompanhamentoMutation();

  const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
  useEffect(() => {
    if (!processoSelecionado) {
      // navigate(configUrls.PROCESSO_LIST_RT);
      window.location.href = configUrls.PROCESSO_LIST_RT;
    }
  }, [processoSelecionado]);

  const { data, isFetching, error } = useGetAcompanhamentosByProcessoQuery(processoSelecionado ?? ISprocesso);

  useEffect(() => {
    if (data) {
      setAcompanhamentos(data);
    } else if (error) {
      enqueueSnackbar('Registro não encontrado!', { variant: 'error' });
    } else if (isFetching) {
      enqueueSnackbar('Buscando registro...', { variant: 'info' });
    } else {
      enqueueSnackbar('Registro não encontrado!', { variant: 'error' });
      // window.location.href = configUrls.PROCESSO_LIST_RT
    }
  }, [data, error, isFetching]);

  const handleExcluirtClick = (rowData: any) => {
    setAcompanhamentoToDelete(rowData);
    setOpenConfirmExcluir(true);
  };
  const handleConfirm = async () => {
    setOpenConfirmExcluir(false);
    await deleteAcompanhamento({ id: acompanhamentoToDelete.id ? acompanhamentoToDelete.id : '' });
  };
  useEffect(() => {
    if (isSuccess) {
      enqueueSnackbar('Registro deletado com sucesso!', { variant: 'success' });
    }
    if (erroDelete) {
      enqueueSnackbar('Registro não deletado!', { variant: 'error' });
    }
  }, [isSuccess, erroDelete]);

  if (loading || isFetching || isLoading) {
    return (
      <Box>
        <CircularProgress />
      </Box>
    );
  }

  const headerRecebidos = (
    <>
      <div className="flex flex-wrap justify-content-end gap-2">
        <span>Acompanhamentos do processo: {processoSelecionado?.numeroProcesso}</span>
      </div>
    </>
  );

  const headerGerados = (
    <>
      <div className="flex flex-wrap justify-content-end gap-2">
        <span>Acompanhamento(s) encontrado(s): {acompanhamentos.length}</span>
      </div>
    </>
  );

  const renderAction = (rowData: any) => {
    return (
      <Box sx={{ display: 'flex', gap: '8px' }}>
        <Tooltip title="Excluir">
          <IconButton color="secondary" aria-label="delete" onClick={() => handleExcluirtClick(rowData)}>
            <GridDeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    );
  };

  const renderData = (rowData: any) => {
    const proc = rowData as Acompanhamento;
    const dataCriacao = proc.dataHoraCriacao ? format(proc.dataHoraCriacao, 'dd/MM/yyyy HH:mm:ss') : 'Data não disponível';

    return (
      <Box>
        <Box>
          <Typography color="secondary" variant="body0" gutterBottom>
            {dataCriacao}
          </Typography>
        </Box>
      </Box>
    );
  };
  const renderGrupo = (rowData: any) => {
    const proc = rowData as Acompanhamento;
    return (
      <Box>
        <Box>
          <Typography color="secondary" variant="body0" gutterBottom>
            {proc.grupoAcompanhamento?.nome ?? ''}
          </Typography>
        </Box>
      </Box>
    );
  };

  const renderDescricao = (rowData: any) => {
    const proc = rowData as Acompanhamento;
    return (
      <Box>
        <Box>
          <Typography color="secondary" variant="body0" gutterBottom>
            {proc.grupoAcompanhamento?.descricao ?? ''}
          </Typography>
        </Box>
      </Box>
    );
  };
  const renderUsuario = (rowData: any) => {
    const proc = rowData as Acompanhamento;

    return (
      <Box>
        <Box>
          <Typography color="secondary" variant="body0" gutterBottom>
            {proc.usuario.nome}
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <>
      <ConfirmDialogList
        open={openConfirmExcluir}
        handleClose={() => {
          setOpenConfirmExcluir(false);
        }}
        title="Confirmar Ação"
        text={['Você tem certeza de que deseja excluir esse acompanhamento? ', acompanhamentoToDelete.descricao ? acompanhamentoToDelete.descricao : '']}
        handleDelete={() => {
          handleConfirm(); // Chama a função handleConfirm
          setOpenConfirmExcluir(false); // Fecha o diálogo
        }}
      />
      <Paper sx={{ width: '100%', height: '100vh', padding: '12px', display: 'flex', flexDirection: 'column' }}>
        criar um botao no list para ver a observacap
        <Grid container padding={2}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <Box display="flex" justifyContent="space-between" mb={2}>
                <Box display="flex">
                  <Typography color="secondary" variant="h6" gutterBottom>
                    Lista de Acompanhamentos para o processo: {processoSelecionado?.numeroProcesso}
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="flex-end">
                  <Button variant="contained" color="secondary" component={Link} to={configUrls.PROCESSO_ACOMPANHAMENTO_CREATE_RT}>
                    Novo
                  </Button>
                </Box>
              </Box>
            </FormControl>
          </Grid>
        </Grid>
        <DataTable
          value={acompanhamentos}
          paginator
          rows={25}
          showGridlines={true}
          size="small"
          columnResizeMode="expand"
          resizableColumns
          dataKey="id"
          header={headerGerados}
          className="custom-datatable"
        >
          <Column header="Data" body={renderData} sortable style={{ width: '30%' }}></Column>
          <Column header="Grupo" body={renderGrupo} sortable style={{ width: '30%' }}></Column>
          <Column header="Descrição" body={renderDescricao} sortable style={{ width: '30%' }}></Column>
          <Column header="Usuário" body={renderUsuario} sortable style={{ width: '30%' }}></Column>
          <Column field="detalhes" header="Detalhes" body={renderAction} style={{ width: 'auto' }}></Column>
        </DataTable>
      </Paper>
    </>
  );
};
